// Get all instances of proactiveTabsBlocks
const proactiveTabsBlocks = document.querySelectorAll(
	'.wp-block-proactive-tabs'
);
const hashURL = window.location.hash ?? false;

// OPEN TAB FUNCTIONS ON DESKTOP

const openTab = (e) => {
	// Check if the clicked element is a tab button
	if (!e.target.matches('.wp-block-proactive-tabs__tabs-list__tab button')) {
		return;
	}

	const tab = e.target.closest('.wp-block-proactive-tabs__tabs-list__tab');
	const allTabs = [
		...tab.parentNode.querySelectorAll(
			'.wp-block-proactive-tabs__tabs-list__tab'
		),
	];
	const tabIndex = allTabs.indexOf(tab);

	// Get the parent container of the tabs and contents
	const container = tab.closest('.wp-block-proactive-tabs');
	const allContents = [
		...container.querySelectorAll('.wp-block-proactive-tab'),
	];

	allTabs.forEach((tab, index) => {
		if (index === tabIndex) {
			tab.classList.add('active');
			allContents[index].style.display = 'block';
			setTimeout(() => {
				allContents[index].classList.add('active');
			}, 10);
		} else {
			tab.classList.remove('active');
			allContents[index].style.display = 'none';
			allContents[index].classList.remove('active');
		}
	});
};

// OPEN ACCORDION MENU IF ENABLED ON MOBILE

const openAccordion = (e, toggle, initial) => {
	// Check if the clicked element is a tab button
	if (!e.target.matches('.proactive-tab__mobile')) {
		return;
	}

	const tab = e.target;
	const content = tab.nextElementSibling;

	if (toggle) {
		// Get the parent container of the tabs and contents
		const container = tab.closest('.wp-block-proactive-tabs');
		const allTabs = container.querySelectorAll('.proactive-tab__mobile');

		allTabs.forEach((otherTab) => {
			if (otherTab !== tab) {
				const otherContent = otherTab.nextElementSibling;
				otherTab.setAttribute('aria-expanded', 'false');
				otherContent.classList.remove('active');
				otherContent.style.display = 'none';
			}
		});
	}

	if (tab.getAttribute('aria-expanded') === 'true') {
		tab.setAttribute('aria-expanded', 'false');
		content.style.display = 'none';
		content.classList.remove('active');
	} else {
		tab.setAttribute('aria-expanded', 'true');
		content.style.display = 'block';
		content.classList.add('active');
	}

	if (!initial) {
		// Scroll to the active tab
		const offset = tab.getBoundingClientRect().top + window.scrollY - 120;

		window.scrollTo({
			top: offset,
			behavior: 'smooth',
		});
	}
};

// LOOP THROUGH ALL BLOCKS AND SET THE ACTIVE TAB

proactiveTabsBlocks.forEach((block) => {
	// Check block settings
	const mobileAccordion = block.dataset.accordions === 'true';
	const firstOpen = block.dataset.first === 'true';
	const toggle = block.dataset.toggle === 'true';
	let activeTab = firstOpen ? 0 : block.dataset.activeTab - 1;

	// Check if the hash is set and if it matches the current block
	if (hashURL && block.querySelector(hashURL)) {
		const tab = block.querySelector(hashURL);
		const tabs = block.querySelectorAll('.wp-block-proactive-tab');
		const index = [...tabs].indexOf(tab);

		activeTab = index;
	}

	if (window.innerWidth < 782 && mobileAccordion) {
		// Set the Open Accordion
		openAccordion(
			{
				target: block.querySelectorAll('.proactive-tab__mobile')[activeTab],
			},
			toggle,
			true
		);

		block.addEventListener('click', (e) => openAccordion(e, toggle, false));
	} else {
		// Set the Open Tab
		openTab({
			target: block.querySelectorAll(
				'.wp-block-proactive-tabs__tabs-list__tab button'
			)[activeTab],
		});

		block.addEventListener('click', openTab);
	}

	// Resize
	window.addEventListener('resize', () => {
		if (window.innerWidth < 782 && mobileAccordion) {
			block.addEventListener('click', (e) => openAccordion(e, toggle, false));
		} else {
			block.addEventListener('click', openTab);
		}
	});
});
